import React, { useState, useEffect, useContext } from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment'
import { AppProvider } from './contexts/AppContext'


import http from './utils/http'
import { getUserUrl } from './constants/urls'

import Router from './Router/Router'

import TranslationsContext from './contexts/TranslationsContext';
import FeedbackBar from './components/FeedbackBar/FeedbackBar';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#fff',
    },
    secondary: {
      main: 'rgb(0, 153, 204)',
    },
    label: {
      main: 'rgba(0, 0, 0, 0.54)',
    }
  },
  overrides: {
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: 'rgb(178, 178, 178)',
        },
      },
    },
  },
})

function readStoredUser() {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) {
      return null
    }
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (e) {
    return null
  }
}

function App() {
  const [user, setUser] = useState(readStoredUser)
  const [feedback, setFeedback] = useState(null)
  const translations = useContext(TranslationsContext).en

  // Set default questionnaire mode to 'edit'
  useEffect(() => {
    if (!localStorage.getItem('questionnaireMode')) {
      localStorage.setItem('questionnaireMode', 'edit')
    }
  });

  // fetch user
  useEffect(() => {
    async function fetchUser() {
      try {
        setFeedback(null)
        const { data: response } = await http.get(getUserUrl())
        const nextUser = response && response.data
        if (!nextUser || typeof nextUser !== 'object' || !nextUser.id) {
          throw new Error('AUTHENTICATION_REQUIRED')
        }

        setUser(nextUser);
        localStorage.setItem('user', JSON.stringify(nextUser))
      } catch (e) {
        setUser(null)
        localStorage.removeItem('user')
        if (e && e.message) {
          setFeedback(e.message)
        }
      }
    }

    fetchUser()
  }, [])

  const context = {
    user,
    translations,
  }

  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <AppProvider value={context}>
          {feedback && <FeedbackBar feedback={feedback} />}
          <CssBaseline />
          <Router />
        </AppProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
}

export default App
